export class ResponseApiGeneric {
	codResp: number;
	msgResp: string;
	dataResp: any;
}

export class ResponseApiGenericException{
	codErr: number;
	msgErr: string;
}